<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'privacy',
})
</script>
<template>
  <div class="privacyPage">
    <NavBar />
    <div class="tab">
      <div :class="{ select: index === 1 }" @click="tabChange(1)">
        <p>{{ lang('TermOfUse') }}</p>
      </div>
      <div :class="{ select: index === 2 }" @click="tabChange(2)">
        <p>{{ lang('privacyPolicy') }}</p>
      </div>
    </div>

    <div class="main">
      <van-image width="100%" fit="contain" :src="imageList" />
      <div style="text-align: center">
        <van-image
          v-if="index === 2"
          width="20%"
          fit="contain"
          :src="rulesPic"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup name="privacy">
import { ref, computed } from 'vue'
import NavBar from '@core/components/NavBar.vue'
import lang from '@/langs'
import { useUserStore } from '@core/stores/user'
import VuePdfEmbed from 'vue-pdf-embed'
import term_cn from '@/assets/images/privacy/term_cn.jpeg'
import term_en from '@/assets/images/privacy/term_en.jpeg'
import privacy_en from '@/assets/images/privacy/privacyEn.jpeg'
import privacy_cn from '@/assets/images/privacy/privacyCn.jpeg'
import rulesPic from '@/assets/images/privacy/rulesPic.png'

const index = ref(1)
const tabChange = (val: number) => {
  index.value = val
}

const userStore = useUserStore()

const imageList = computed(() => {
  const lang = userStore.header.language.toLowerCase()
  const isEn = lang === 'en'

  if (index.value === 2) {
    return isEn ? privacy_en : privacy_cn
  } else {
    return isEn ? term_en : term_cn
  }
})
</script>

<style scoped lang="less">
.privacyPage {
  width: 100vw;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
    canvas {
      width: 100%;
    }
  }
  .tab {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 10px;
    > div {
      padding: 5px 12px;
      border: 1px solid red;
      color: red;
      font-size: 12px;
    }
    .select {
      background: red;
      color: white;
    }
  }
}
</style>
